import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import PersonalInformation from 'components/Account/Informations/PersonalInformation/PersonalInformation';
import AddressInformation from 'components/Account/Informations/AddressInformation/AddressInformation';
import OptionNotPossibleConditions from 'components/Common/TermConditions/OptionNotPossibleConditions';
import useCurrentCountry from 'hooks/useCurrentCountry';
import useGtmPageView from 'hooks/gtm/useGtmPageView';
import { GTM_PAGE_ACCOUNT } from 'settings/gtm/gtmPageView';

import styles from './page.module.scss';

export default function Informations(): JSX.Element {
  const { t } = useTranslation(['summaryPage']);
  const { isUk } = useCurrentCountry();

  useGtmPageView(GTM_PAGE_ACCOUNT, '');

  return (
    <div>
      <Helmet>
        <title>
          {t('META_TITLE_TEMPLATE', {
            title: t('SUMMARY_META_TITLE'),
            ns: 'translation',
          })}
        </title>
      </Helmet>
      <PersonalInformation />
      <AddressInformation />
      {isUk && (
        <OptionNotPossibleConditions
          asteriskPrefix={'**'}
          classes={{ container: styles.termsBlock, wrapper: styles.termsSpan }}
        />
      )}
    </div>
  );
}
